import * as constants from '../constants/constants';
import { toastSuccess, toastError } from '../utils/toastMessage';
import API from '../utils/API';
import {
  dish_tags_id,
  eating_tags_id,
  product_tags_id,
} from '../Components/YouSlim2.0/youslim2.0_Constants';

export const setAllTags = (allTags) => {
  return {
    type: constants.GET_NEW_YOUSLIM_TAGS,
    payload: {
      allTags,
    },
  };
};

export const setIsVideoModalOpen = (isOpen) => {
  return {
    type: constants.NEW_SET_IS_VIDEO_MODAL_OPEN,
    payload: {
      isVideoModalOpen: isOpen,
    },
  };
};
export const setActiveVideo = (activeVideo) => {
  return {
    type: constants.NEW_SET_ACTIVE_VIDEO,
    payload: {
      activeVideo: activeVideo,
    },
  };
};

export const setCurrentProduct = (product) => {
  return {
    type: constants.SET_CURRENT_PRODUCT,
    payload: {
      product,
    },
  };
};

export const setCurrentTraining = (currentTraining) => {
  return {
    type: constants.SET_CURRENT_TRAINING,
    payload: {
      currentTraining,
    },
  };
};

export const setCurrentDish = (dish) => {
  return {
    type: constants.SET_CURRENT_DISH,
    payload: {
      dish,
    },
  };
};

export const setSearchProductLoadingStarted = () => {
  return {
    type: constants.SET_SEARCH_PRODUCT_LOADING_STARTED,
  };
};

export const setSearchProductLoadingEnd = () => {
  return {
    type: constants.SET_SEARCH_PRODUCT_LOADING_END,
  };
};

export const setSearchDishLoadingStarted = () => {
  return {
    type: constants.SET_SEARCH_DISH_LOADING_STARTED,
  };
};
export const setSearchDishLoadingEnd = () => {
  return {
    type: constants.SET_SEARCH_DISH_LOADING_END,
  };
};

export const setSearchTrainingLoadingStarted = () => {
  return {
    type: constants.SET_SEARCH_TRAINING_LOADING_STARTED,
  };
};

export const setSearchTrainingLoadingEnd = () => {
  return {
    type: constants.SET_SEARCH_TRAINING_LOADING_END,
  };
};

export const setProductLoading = () => {
  return {
    type: constants.SET_PRODUCT_LOADING,
  };
};

export const finishProductLoading = () => {
  return {
    type: constants.FINISH_PRODUCT_LOADING,
  };
};

export const setDishLoading = () => {
  return {
    type: constants.SET_DISH_LOADING,
  };
};

export const finishDishLoading = () => {
  return {
    type: constants.FINISH_DISH_LOADING,
  };
};

export const setTrainingLoading = () => {
  return {
    type: constants.SET_TRAINING_LOADING,
  };
};

export const finishTrainingLoading = () => {
  return {
    type: constants.FINISH_TRAINING_LOADING,
  };
};

export const setAllEatingTags = (allEatingTags) => {
  return {
    type: constants.GET_NEW_YOUSLIM_EATING_TAGS,
    payload: {
      allEatingTags,
    },
  };
};

export const setProducts = (products) => {
  return {
    type: constants.SET_NEW_YOUSLIM_PRODUCTS,
    payload: {
      products,
    },
  };
};

export const setDishes = (dishes) => {
  return {
    type: constants.SET_NEW_YOUSLIM_DISH,
    payload: {
      dishes,
    },
  };
};

export const setAllRecipeTags = (allRecipeTags) => {
  return {
    type: constants.GET_NEW_YOUSLIM_RECIPE_TAGS,
    payload: {
      allRecipeTags,
    },
  };
};

export const setTagsCategories = (tagsCategories) => {
  return {
    type: constants.SET_TAGS_CATEGORIES,
    payload: {
      tagsCategories,
    },
  };
};

export const setProductToFind = (productToFind) => {
  return {
    type: constants.SET_PRODUCT_TO_FIND,
    payload: {
      productToFind,
    },
  };
};

export const setComplexity = (complexity) => {
  return {
    type: constants.SET_COMPLEXITY,
    payload: {
      complexity,
    },
  };
};

export const setTrainingType = (trainingType) => {
  return {
    type: constants.SET_TRAINING_TYPE,
    payload: {
      trainingType,
    },
  };
};
export const setTrainingGears = (trainingGears) => {
  return {
    type: constants.SET_TRAINING_GEARS,
    payload: {
      trainingGears,
    },
  };
};
export const setTraining = (training) => {
  return {
    type: constants.SET_TRAINING,
    payload: {
      training,
    },
  };
};

export const setTrainingTemplate = (trainingTemplate) => {
  return {
    type: constants.SET_TRAINING_TEMPLATE,
    payload: {
      trainingTemplate,
    },
  };
};

export const setTrainingTemplateId = (trainingTemplateId) => {
  return {
    type: constants.SET_TRAINING_TEMPLATE_ID,
    payload: {
      trainingTemplateId,
    },
  };
};

export const setMarathonsList = (marathonsList) => {
  return {
    type: constants.SET_MARATHONS_LIST,
    payload: {
      marathonsList,
    },
  };
};

export const setMarathonData = (marathonData) => {
  return {
    type: constants.SET_MARATHON_DATA,
    payload: {
      marathonData,
    },
  };
};

export const setUserMenuMarathon = (userMenuMarathon) => {
  return {
    type: constants.SET_USER_MENU_MARATHON,
    payload: {
      userMenuMarathon,
    },
  };
};

export const setCreateCourseLoading = () => {
  return {
    type: constants.SET_CREATE_COURSE_LOADING,
  };
};

export const finishCreateCourseLoading = () => {
  return {
    type: constants.FINISH_CREATE_COURSE_LOADING,
  };
};

export const getComplexity = () => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/daily-training/complexity`)
      .then((response) => {
        dispatch(setComplexity(response.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Список уровней сложности видео не был получен');
      });
  };
};

export const getTrainingType = () => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/daily-training/type`)
      .then((response) => {
        dispatch(setTrainingType(response.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось получить список типов тренировок');
      });
  };
};

export const getTrainingGears = () => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/tags?categories[]=4`)
      .then((response) => {
        dispatch(setTrainingGears(response.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось получить теги инвентаря');
      });
  };
};

export const getTrainingTemplate = () => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/training-template`)
      .then((response) => {
        dispatch(setTrainingTemplate(response.data.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось получить шаблоны тренировок');
      });
  };
};
export const getTrainingTemplateId = (id) => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/training-template/${id}`)
      .then((response) => {
        dispatch(setTrainingTemplateId(response.data.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось получить шаблоны тренировок');
      });
  };
};

export const getMarathonsList = () => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/marathons`)
      .then((response) => {
        dispatch(setMarathonsList(response.data));
        console.log(response.data,'marathons');
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось получить марафоны');
      });
  };
};

export const getMarathonData = (id) => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/marathons/${id}`)
      .then((response) => {
        dispatch(setMarathonData(response.data));
        console.log(response.data,'marathon data');
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось получить информацию о марафоне');
      });
  };
};

export const getUserMenuMarathon = (name = '',id) => {
  return (dispatch) => {
    // API.get(`https://new-slimadmin.site.supplies/api/user/search?name=${name}&marathon=${id}`)
    API.get(`https://new-slimadmin.site.supplies/api/user/search?name=${name}&marathon=1`)

      .then((response) => {
        dispatch(setUserMenuMarathon(response.data));
        console.log(response.data,'user menu marathon data');
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось получить меню в марафоне');
      });
  };
};

export const createMarathon = (data) =>{
  return (dispatch) => {
    API.post(`https://new-slimadmin.site.supplies/api/marathons`, {
      name: data.name,
      first_start_date: data.first_start_date,
      second_start_date: data.second_start_date,
      url_group_chat: data.url_group_chat,
      url_marathon_channel: data.url_marathon_channel,
      up_to_65_normal_user_id: data.up_to_65_normal_user_id,

      from_65_to_80_normal_user_id: data.from_65_to_80_normal_user_id,
      from_80_normal_user_id: data.from_80_normal_user_id,
      up_to_65_simplified_user_id: data.up_to_65_simplified_user_id,

      from_65_to_80_simplified_user_id: data.from_65_to_80_simplified_user_id,
      from_80_simplified_user_id: data.from_80_simplified_user_id,
    })
    .then((response) => {
      toastSuccess('Марафон успешно создан');
      dispatch(finishTrainingLoading());
    })
    .catch((err) => {
      dispatch(finishTrainingLoading());
      if (err && err.response && err.response.data && err.response.data.message) {
        toastError(err.response.data.message);
      } else toastError('Не удалось создать марафон');
    });
  };
};

export const updateMarathon = (data, id) =>{
  return (dispatch) => {
    dispatch(setTrainingLoading());
    // API.post(`https://new-slimadmin.site.supplies/api/marathons/${id}`, {
      API.put(`https://new-slimadmin.site.supplies/api/marathons/${id}`, {
      name: data.name,
      first_start_date: data.first_start_date,
      second_start_date: data.second_start_date,
      url_group_chat: data.url_group_chat,
      url_marathon_channel: data.url_marathon_channel,
      up_to_65_normal_user_id: data.up_to_65_normal_user_id,

      from_65_to_80_normal_user_id: data.from_65_to_80_normal_user_id,
      from_80_normal_user_id: data.from_80_normal_user_id,
      up_to_65_simplified_user_id: data.up_to_65_simplified_user_id,

      from_65_to_80_simplified_user_id: data.from_65_to_80_simplified_user_id,
      from_80_simplified_user_id: data.from_80_simplified_user_id,
   
    })
    .then(() => {
      toastSuccess('Марафон успешно обновлён');
      dispatch(finishTrainingLoading());
    })
    .catch((err) => {
      dispatch(finishTrainingLoading());
      if (err && err.response && err.response.data && err.response.data.message) {
        toastError(err.response.data.message);
      } else toastError('Не удалось обновить марафон');
    });
  };
};


export const getTraining = () => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/daily-training/`)
      .then((response) => {
        dispatch(setTraining(response.data.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось получить список тренировок');
      });
  };
};

export const getTagsCategories = () => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/tags`)
      .then((response) => {
        dispatch(setTagsCategories(response.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Категории тегов не найдены');
      });
  };
};

export const getProductTags = (tags = product_tags_id, isUserPage = false) => {
  let requestURL = `https://new-slimadmin.site.supplies/api/tags?categories[]=${tags}`;
  if (isUserPage)
    requestURL = `https://new-slimadmin.site.supplies/api/tags?categories[]=${tags}&for=user-page`;
  return (dispatch) => {
    API.get(requestURL)
      .then((response) => {
        dispatch(setAllTags(response.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Теги не найдены');
      });
  };
};

export const getRecipeTags = (tags = dish_tags_id) => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/tags?categories[]=${tags}`)
      .then((response) => {
        dispatch(setAllRecipeTags(response.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Теги не найдены');
      });
  };
};

export const getEatingTags = (tags = eating_tags_id) => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/tags?categories[]=${tags}`)
      .then((response) => {
        dispatch(setAllEatingTags(response.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Теги не найдены');
      });
  };
};

export const createProduct = (data, clearData) => {
  return (dispatch) => {
    dispatch(setProductLoading());
    API.post('https://new-slimadmin.site.supplies/api/products', {
      name: data.name,
      calories: data.calories,
      animal_protein: data.animal_proteins || 0,
      vegetable_protein: data.plant_proteins || 0,
      saturated_fat: data.saturated_fats || 0,
      unsaturated_fats: data.unsaturated_fats || 0,
      simple_carbohydrates: data.simple_carbohydrates || 0,
      complex_carbohydrates: data.complex_carbohydrates || 0,
      cellulose: data.cellulose || 0,
      measure_id: data.measure_id,
      tags: data.tags,
      show_quantity: data.show_quantity,
    })
      .then(() => {
        dispatch(finishProductLoading());
        toastSuccess('Продукт успешно создан');
        clearData();
      })
      .catch((err) => {
        dispatch(finishProductLoading());
        dispatch(setProductLoading());
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось сохранить продукт');
      });
  };
};

export const updateProduct = (data, id) => {
  return (dispatch) => {
    dispatch(setProductLoading());
    API.put(`https://new-slimadmin.site.supplies/api/products/${id}`, {
      name: data.name,
      calories: data.calories,
      animal_protein: data.animal_proteins,
      vegetable_protein: data.plant_proteins,
      saturated_fat: data.saturated_fats,
      unsaturated_fats: data.unsaturated_fats,
      simple_carbohydrates: data.simple_carbohydrates,
      complex_carbohydrates: data.complex_carbohydrates,
      cellulose: data.cellulose,
      measure_id: data.measure_id,
      tags: data.tags,
      description: data.description,
      file: data.file,
      show_quantity: data.show_quantity,
    })
      .then(() => {
        dispatch(finishProductLoading());
        toastSuccess('Продукт успешно обновлен');
      })
      .catch((err) => {
        dispatch(finishProductLoading());

        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось обновить продукт');
      });
  };
};

export const updateTraining = (data, id, clearData) => {
  return (dispatch) => {
    dispatch(setTrainingLoading());
    const training = {
      title: data.title,
      description: data.description,
      complexity_training_id: data.complexity_training_id,
      type_video_training_id: data.type_video_training_id,
    };
    const fd = new FormData();
    fd.append('_method', 'PUT');
    fd.append('title', training.title);
    fd.append('description', training.description);
    fd.append('complexity_training_id', training.complexity_training_id);
    fd.append('type_video_training_id', training.type_video_training_id);
    fd.append('is_draft', data.is_draft);
    if (data.duration) fd.append('duration', data.duration);

    if (data.video) fd.append('video', data.video);
    if (data.preview) fd.append('preview', data.preview);
    if (data.time_stamps && data.time_stamps.length)
      fd.append('time_stamps', JSON.stringify(data.time_stamps));
    if (data.gears && data.gears.length) fd.append('gears', JSON.stringify(data.gears));

    dispatch(setTrainingLoading());
    API.post(`https://new-slimadmin.site.supplies/api/daily-training/${id}`, fd, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(() => {
        dispatch(finishTrainingLoading());
        toastSuccess('Тренировка успешно обновлена');
        clearData();
      })
      .catch((err) => {
        dispatch(finishTrainingLoading());
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось обновить тренировку');
      });
  };
};

export const createRecipe = (data, clearData) => {
  return (dispatch) => {
    const recipe = {
      title: data.title,
      recipes: data.recipes,
      tags: { tags: data.tags },
    };
    const fd = new FormData();
    fd.append('title', recipe.title);
    fd.append('recipes', JSON.stringify(recipe.recipes));
    fd.append('tags', JSON.stringify(recipe.tags));
    if (data.recipes_text.length)
      fd.append('recipes_text', JSON.stringify({ recipes_text: data.recipes_text }));
    if (data.description) fd.append('description', data.description);
    if (data.file) fd.append('file', data.file);
    if (data.cooking_time) fd.append('cooking_time', data.cooking_time);
    dispatch(setDishLoading());
    API.post('https://new-slimadmin.site.supplies/api/dishes', fd, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(() => {
        dispatch(finishDishLoading());
        toastSuccess('Блюдо успешно создано');
        clearData();
      })
      .catch((err) => {
        dispatch(finishDishLoading());
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось сохранить блюдо');
      });
  };
};

export const createTraining = (data, clearData) => {
  return (dispatch) => {
    const training = {
      title: data.title,
      description: data.description,
      complexity_training_id: data.complexity_training_id,
      type_video_training_id: data.type_video_training_id,
    };
    const fd = new FormData();
    fd.append('title', training.title);
    fd.append('description', training.description);
    fd.append('complexity_training_id', training.complexity_training_id);
    fd.append('type_video_training_id', training.type_video_training_id);
    if (data.duration) fd.append('duration', data.duration);

    if (data.video) fd.append('video', data.video);
    if (data.preview) fd.append('preview', data.preview);
    if (data.time_stamps && data.time_stamps.length)
      fd.append('time_stamps', JSON.stringify(data.time_stamps));
    if (data.gears && data.gears.length) fd.append('gears', JSON.stringify(data.gears));
    dispatch(setTrainingLoading());
    API.post('https://new-slimadmin.site.supplies/api/daily-training/', fd, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(() => {
        dispatch(finishTrainingLoading());
        toastSuccess('Тренировка успешно создана');
        clearData();
      })
      .catch((err) => {
        dispatch(finishTrainingLoading());
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось сохранить тренировку');
      });
  };
};

export const createTrainingTemplate = (data, clearData) => {
  return (dispatch) => {
    API.post(`https://new-slimadmin.site.supplies/api/training-template`, {
      name: data.name,
      description: data.description,
      type_training_video_id: data.type_training_video_id,
      complexity_training_id: data.complexity_training_id,
      count_trainings: data.count_trainings,
      trainings: data.trainings,
    })

      .then((response) => {
        toastSuccess('Шаблон тренировки успешно создан');
        dispatch(finishTrainingLoading());
        clearData();
      })
      .catch((err) => {
        dispatch(finishTrainingLoading());
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось создать шаблоны тренировки');
      });
  };
};

export const updateTrainingTemplate = (data, id) => {
  return (dispatch) => {
    dispatch(setTrainingLoading());
    API.put(`https://new-slimadmin.site.supplies/api/training-template/${id}`, {
      name: data.name,
      description: data.description,
      type_training_video_id: data.type_training_video_id,
      complexity_training_id: data.complexity_training_id,
      count_trainings: data.count_trainings,
      trainings: data.trainings,
    })
      .then(() => {
        dispatch(finishTrainingLoading());
        toastSuccess('Шаблон тренировки успешно обновлён');
      })
      .catch((err) => {
        dispatch(finishTrainingLoading());
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось обновить шаблон тренировки');
      });
  };
};

export const updateRecipe = (data, id) => {
  return (dispatch) => {
    const recipe = {
      title: data.title,
      recipes: data.recipes,
      tags: { tags: data.tags },
    };
    const fd = new FormData();
    fd.append('_method', 'put');
    fd.append('title', recipe.title);
    fd.append('is_draft', data.is_draft);
    fd.append('recipes', JSON.stringify(recipe.recipes));
    fd.append('tags', JSON.stringify(recipe.tags));
    if (data.recipes_text.length)
      fd.append('recipes_text', JSON.stringify({ recipes_text: data.recipes_text }));
    if (data.description) fd.append('description', data.description);
    if (data.file) fd.append('file', data.file);
    if (data.cooking_time) fd.append('cooking_time', data.cooking_time);
    dispatch(setDishLoading());
    API.post(`https://new-slimadmin.site.supplies/api/dishes/${id}`, fd, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(() => {
        dispatch(finishDishLoading());
        toastSuccess('Блюдо успешно обновлено');
      })
      .catch((err) => {
        dispatch(finishDishLoading());
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось обновить блюдо');
      });
  };
};

export const getProductsByName = (name = '') => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/products?name=${name}`)
      .then((respons) => {
        dispatch(setProducts(respons.data.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Продукт не найден');
      });
  };
};

export const getProductsListByName = (
  name = '',
  products,
  sortProductByAlphabet,
  newProductsList,
  index,
  setProductList,
) => {
  return () => {
    const newProductsItems = [];

    API.get(`https://new-slimadmin.site.supplies/api/products?name=${name}`)
      .then((respons) => {
        const oldProductsList = respons.data.data;
        sortProductByAlphabet(oldProductsList, newProductsItems);
        newProductsList[index] = newProductsItems;
        setProductList([...newProductsList]);
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Продукт не найден');
      });
  };
};

export const getDishListByName = (name = '') => {
  return (dispatch) => {
    dispatch(setSearchDishLoadingStarted());
    API.get(`https://new-slimadmin.site.supplies/api/dishes?name=${name}`)
      .then((respons) => {
        dispatch(setSearchDishLoadingEnd());
        dispatch(setDishes(respons.data));
      })
      .catch((err) => {
        dispatch(setSearchDishLoadingEnd());
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Продукт не найден');
      });
  };
};

export const getTrainingListByName = (title = '', type_video = [], complexity = [], tags = []) => {
  return (dispatch) => {
    dispatch(setSearchTrainingLoadingStarted());

    API.get(
      `https://new-slimadmin.site.supplies/api/daily-training?title=${title}&type_video=${type_video}&complexity=${complexity}&tags=${tags}`,
    )
      .then((response) => {
        dispatch(setSearchTrainingLoadingEnd());
        dispatch(setTraining(response.data.data));
      })
      .catch((err) => {
        dispatch(setSearchDishLoadingEnd());
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Тренировки не найдены');
      });
  };
};

export const setNumberOfLinkedRecipes = (numberOfLinkedRecipes) => {
  return {
    type: constants.GET_NUMBER_OF_LINKED_RECIPES,
    payload: {
      numberOfLinkedRecipes,
    },
  };
};

export const setCheckTrainDelete = (isTrainingDelete) => {
  return {
    type: constants.SET_TRAINING_SHOULD_DELETE,
    payload: {
      isTrainingDelete,
    },
  };
};

export const set = (numberOfLinkedRecipes) => {
  return {
    type: constants.GET_NUMBER_OF_LINKED_RECIPES,
    payload: {
      numberOfLinkedRecipes,
    },
  };
};

export const getNumberOfLinkedRecipes = (id) => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/prepare-for-destroy/${id}`)
      .then((respons) => {
        dispatch(setNumberOfLinkedRecipes(respons.data.number));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Продукт не найден');
      });
  };
};

export const deleteProduct = (id) => {
  return (dispatch) => {
    dispatch(setProductLoading());
    API.delete(`https://new-slimadmin.site.supplies/api/products/${id}`)
      .then(() => {
        dispatch(finishProductLoading());
        toastSuccess('Продукт успешно удален');
        dispatch(getProductsByName());
      })
      .catch((err) => {
        dispatch(finishProductLoading());

        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Продукт не найден');
      });
  };
};

export const deleteDish = (id) => {
  return (dispatch) => {
    dispatch(setDishLoading());
    API.delete(`https://new-slimadmin.site.supplies/api/dishes/${id}`)
      .then(() => {
        dispatch(finishDishLoading());
        toastSuccess('Блюдо успешно удалено');
        dispatch(getDishListByName());
      })
      .catch((err) => {
        dispatch(finishDishLoading());
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Блюдо не найдено');
      });
  };
};

export const checkShouldTrainBeDeleted = (id) => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/daily-training/check-on-delete/${id}`)
      .then((response) => {
        dispatch(setCheckTrainDelete(response.data.is_delete));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Видео не найдено');
      });
  };
};

export const deleteTraining = (id) => {
  return (dispatch) => {
    dispatch(setTrainingLoading());
    API.delete(`https://new-slimadmin.site.supplies/api/daily-training/destroy/${id}`)
      .then(() => {
        dispatch(finishTrainingLoading());
        toastSuccess('Тренировка успешно удалена');
        dispatch(getTrainingListByName());
      })
      .catch((err) => {
        dispatch(finishTrainingLoading());
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Тренировка не найдена');
      });
  };
};

// users requests

export const setUsers = (users) => {
  return {
    type: constants.SET_NEW_YOUSLIM_USER,
    payload: {
      users,
    },
  };
};

export const setUserTarget = (target) => {
  return {
    type: constants.SET_NEW_YOUSLIM_USER_TARGET,
    payload: {
      target,
    },
  };
};

export const setGeneratorResponse = (data) => {
  return {
    type: constants.SET_GENERATOR_DATA,
    payload: {
      data,
    },
  };
};

export const getUsers = () => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/users`)
      .then((respons) => {
        dispatch(setUsers(respons.data.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Пользователи не найдены');
      });
  };
};

export const createUser = (data, setIsCreateUserPopup) => {
  return (dispatch) => {
    API.post(`https://new-slimadmin.site.supplies/api/users`, {
      name: data.name,
      params: data.params,
      tags: data.tags,
      tag_country_id: data.tag_country_id,
    })
      .then((respons) => {
        toastSuccess('Пользователь успешно создан');
        dispatch(setUserTarget(respons.data));
        setIsCreateUserPopup(false);
        dispatch(getUsers());
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось создать пользователя');
      });
  };
};

export const updateUser = (data) => {
  return (dispatch) => {
    API.put(`https://new-slimadmin.site.supplies/api/users/${data.id}`, {
      name: data.name,
      params: data.params,
      tags: data.tags,
      tag_country_id: data.tag_country_id,
    })
      .then((respons) => {
        toastSuccess('Пользователь успешно обновлен');
        dispatch(setUserTarget(respons.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось обновить пользователя');
      });
  };
};

export const deleteUser = (id) => {
  return (dispatch) => {
    API.delete(`https://new-slimadmin.site.supplies/api/users/${id}`)
      .then(() => {
        toastSuccess('Пользователь успешно удален');
        dispatch(getUsers());
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось удалить пользователя');
      });
  };
};

export const getGenetatorResults = (id) => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/get-menus-for-user/${id}`)
      .then((respons) => {
        // dispatch(setUsers(respons.data));
        dispatch(setGeneratorResponse(respons.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Пользователи не найдены');
      });
  };
};

export const runGenerator = (data, setIsGenerateRun) => {
  const postData = {
    menu_structure: {},
    ff_limit: 0,
    repeat: 1,
  };
  if (data.breakfast[0].length) {
    postData.menu_structure.breakfast = data.breakfast;
  }
  if (data && data.morningSnack.length && data.morningSnack[0].length)
    postData.menu_structure.morningSnack = data.morningSnack;
  if (data && data.lunch.length && data.lunch[0].length) postData.menu_structure.lunch = data.lunch;
  if (data && data.afternoonSnack.length && data.afternoonSnack[0].length)
    postData.menu_structure.afternoonSnack = data.afternoonSnack;
  if (data && data.dinner.length && data.dinner[0].length)
    postData.menu_structure.dinner = data.dinner;
  if (data && data.eveningSnack.length && data.eveningSnack[0].length)
    postData.menu_structure.eveningSnack = data.eveningSnack;
  if (data && data.ff_limit > 0) postData.ff_limit = data.ff_limit;
  if (data && data.repeat > 0) postData.repeat = data.repeat;
  return (dispatch) => {
    API.post(`https://new-slimadmin.site.supplies/api/generate-new-menu/${data.id}`, postData)
      .then((respons) => {
        toastSuccess('Генерация прошла успешно');
        dispatch(getGenetatorResults(data.id));
        setIsGenerateRun(false);
      })
      .catch((err) => {
        setIsGenerateRun(false);
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось сгенерировать меню');
      });
  };
};

export const getDishById = (id) => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/dishes/${id}`)
      .then((respons) => {
        dispatch(setCurrentDish(respons.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось получить блюдо');
      });
  };
};

export const getProductById = (id) => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/products/${id}`)
      .then((respons) => {
        dispatch(setCurrentProduct(respons.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось получить продукт');
      });
  };
};

export const getTrainById = (id) => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/daily-training/${id}`)
      .then((response) => {
        dispatch(setCurrentTraining(response.data.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось получить тренировку');
      });
  };
};

export const setUsersList = (usersList) => {
  return {
    type: constants.SET_USERS_LIST,
    payload: {
      usersList,
    },
  };
};

export const setUsersListLoading = () => {
  return {
    type: constants.SET_USERS_LIST_LOADING,
  };
};

export const finishUsersListLoading = () => {
  return {
    type: constants.FINISH_USERS_LIST_LOADING,
  };
};

export const getUsersList = (user) => {
  return (dispatch) => {
    dispatch(setUsersListLoading());
    let searchUrl = '';
    if (user.name) searchUrl += `&name=${user.name}`;

    if (user.type_payment > 0) searchUrl += `&type_payment=${user.type_payment}`;
    if (user.active_course === false || user.active_course === true)
      searchUrl += `&active_course=${user.active_course}`;
    if (user.course_is_paid === false) searchUrl += `&course_is_paid=false`;

    if (user.course_is_paid === true) searchUrl += `&course_is_paid=true`;

    if (user.user_create_from_date)
      searchUrl += `&user_create_from_date=${user.user_create_from_date}`;
    if (user.user_create_to_date) searchUrl += `&user_create_to_date=${user.user_create_to_date}`;
    API.get(`https://new-slimadmin.site.supplies/api/user-list?page=${user.page || 1}${searchUrl}`)
      .then((response) => {
        dispatch(finishUsersListLoading());
        dispatch(setUsersList(response.data));
      })
      .catch((err) => {
        dispatch(finishUsersListLoading());
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Пользователь не найден');
      });
  };
};

export const setUserInfo = (user) => {
  return {
    type: constants.SET_NEW_YOUSLIM_USER_INFO,
    payload: {
      user,
    },
  };
};

export const getUser = (userId) => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/user/info/${userId}`)
      .then((respons) => {
        dispatch(setUserInfo(respons.data.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Пользователь не найден');
      });
  };
};

export const setUsersListForSelect = (usersListForSelect) => {
  return {
    type: constants.SET_USERS_LIST_FOR_SELECT,
    payload: {
      usersListForSelect,
    },
  };
};

export const setUpdateUserStartDate = (start_date, index) => {
  return {
    type: constants.SET_UPDATE_USER_START_DATE,
    payload: {
      start_date,
      index,
    },
  };
};

export const setUpdateUserIsPaid = (is_paid, index) => {
  return {
    type: constants.SET_UPDATE_USER_IS_PAID,
    payload: {
      is_paid,
      index,
    },
  };
};

export const getUsersListForSelect = (name = '') => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/user/search?name=${name}`)
      .then((respons) => {
        dispatch(setUsersListForSelect(respons.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Пользователи не найдены');
      });
  };
};

export const updateUserStartDate = (start_date, id, index) => {
  return (dispatch) => {
    API.post(`https://new-slimadmin.site.supplies/api/course/update-start-date/${id}`, {
      start_date,
    })
      .then((respons) => {
        toastSuccess('Пользователь успешно обновлен');

        if (respons.status === 200) {
          dispatch(setUpdateUserStartDate(start_date, index));
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось обновить пользователя');
      });
  };
};

export const updateUserIsPaid = (is_paid, id, index) => {
  return (dispatch) => {
    API.post(`https://new-slimadmin.site.supplies/api/course/update-is-paid/${id}`, {
      is_paid,
    })
      .then((respons) => {
        toastSuccess('Пользователь успешно обновлен');

        if (respons.status === 200) {
          dispatch(setUpdateUserIsPaid(is_paid, index));
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось обновить пользователя');
      });
  };
};

export const setUserMenuInCourse = (userMenuInCourse) => {
  return {
    type: constants.SET_UPDATE_MENU_IN_COURSE,
    payload: {
      userMenuInCourse,
    },
  };
};
export const setUserTrainingCourse = (userTrainingCourse) => {
  return {
    type: constants.SET_TRAINING_COURSE,
    payload: {
      userTrainingCourse,
    },
  };
};

export const getUserMenuInCourse = (courseID) => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/course/get-menu/${courseID} `)
      .then((respons) => {
        dispatch(setUserMenuInCourse(respons.data));
      })

      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Меню не найдено');
      });
  };
};

export const getUserTrainingCourse = (training_course_id) => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/training-course/${training_course_id} `)
      .then((response) => {
        dispatch(setUserTrainingCourse(response.data.data));
      })
      .catch((err) => {
        toastError('Курс не найден');
      });
  };
};

export const updateUserTrainingCourse = (data, training_course_id) => {
  return (dispatch) => {
    dispatch(setTrainingLoading());
    API.put(`https://new-slimadmin.site.supplies/api/training-course/${training_course_id} `, {
      description: data.description,
      trainings: data.trainings,
    })
      .then(() => {
        dispatch(finishTrainingLoading());
        toastSuccess('Курс тренировок успешно обновлён');
      })
      .catch(() => {
        dispatch(finishTrainingLoading());
        toastError('Не удалось обновить курс тренировок');
      });
  };
};

export const setMealsToReplaceList = (mealsToReplaceList) => {
  return {
    type: constants.SET_MEALS_TO_REPLACE_LIST,
    payload: {
      mealsToReplaceList,
    },
  };
};

export const getMealsToReplaceList = ({ meal_id, position_id, user_id, recipe_id }) => {
  return (dispatch) => {
    API.get(
      `https://new-slimadmin.site.supplies/api/dish-replacements/?user_id=${user_id}&position_id=${position_id}&meal_id=${meal_id}&recipe_id=${recipe_id}`,
    )
      .then((respons) => {
        dispatch(setMealsToReplaceList(respons.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Подходящие блюда не найдены');
      });
  };
};

export const replaceUserMenuDish = ({
  portion_id,
  dish_id,
  generate_id,
  serial_number_week,
  meal_id,
  serial_number_meal,
  courseId,
  closeModal,
}) => {
  return (dispatch) => {
    API.post(`https://new-slimadmin.site.supplies/api/dish-replacements`, {
      portion_id,
      dish_id,
      generate_id,
      serial_number_week,
      meal_id,
      serial_number_meal,
    })
      .then((respons) => {
        toastSuccess('Блюдо успешно обновлено');

        if (respons.status === 200) {
          dispatch(getUserMenuInCourse(courseId));
          closeModal();
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось обновить блюдо');
      });
  };
};

export const addDishToMenu = ({
  portion_id,
  dish_id,
  generating_id,
  serial_number_week,
  meal_id,
  dish_tag_id,
  courseId,
  closeModal,
}) => {
  return (dispatch) => {
    API.post(`https://new-slimadmin.site.supplies/api/added-dish-in-generating`, {
      portion_id,
      dish_id,
      generating_id,
      serial_number_week,
      meal_id,
      dish_tag_id,
    })
      .then((respons) => {
        toastSuccess('Блюдо успешно добавлено');

        if (respons.status === 200) {
          dispatch(getUserMenuInCourse(courseId));
          closeModal();
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось добавить блюдо');
      });
  };
};

export const setDishForReplacement = (dishForReplacement) => {
  return {
    type: constants.SET_DISH_FOR_REPLACEMENT,
    payload: {
      dishForReplacement,
    },
  };
};

export const searchDishForReplacement = (name = '') => {
  return (dispatch) => {
    API.get(`https://new-slimadmin.site.supplies/api/dishes/search-for-replacement?title=${name}`)
      .then((respons) => {
        dispatch(setDishForReplacement(respons.data.data));
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Подходящие блюда не найдены');
      });
  };
};

export const onDeleteDish = ({
  generating_id,
  serial_number_week,
  serial_number_meal,
  meal_id,
  courseId,
  closeModal,
}) => {
  return (dispatch) => {
    API.delete(
      `https://new-slimadmin.site.supplies/api/delete-dish-in-generating?generating_id=${generating_id}&serial_number_week=${serial_number_week}&serial_number_meal=${serial_number_meal}&meal_id=${meal_id}`,
    )
      .then((respons) => {
        toastSuccess('Блюдо успешно удалено');

        if (respons.status === 200) {
          dispatch(getUserMenuInCourse(courseId));
          closeModal();
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось удалить блюдо');
      });
  };
};

export const createCourse = ({
  user,
  start_date,
  duration,
  menu_structure,
  ff_limit,
  repeat,
  training_template_id,
  onClose,
}) => {
  return (dispatch) => {
    dispatch(setCreateCourseLoading());
    API.post(`https://new-slimadmin.site.supplies/api/generate-manual-course/${user}`, {
      start_date: start_date,
      duration: duration,
      menu_structure: menu_structure,
      ff_limit: ff_limit,
      repeat: repeat,
      training_template_id: training_template_id,
    })
      .then(() => {
        dispatch(finishCreateCourseLoading());
        toastSuccess('Курс успешно создан');
        onClose();
      })
      .catch((err) => {
        dispatch(finishCreateCourseLoading());
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось создать курс');
      });
  };
};

export const setUpdateStatusCourse = (index) => {
  return {
    type: constants.SET_UPDATE_USER_STATUS_COURSE,
    payload: {
      index,
    },
  };
};

export const onUpdateStatusCourse = (course_id, start_date, index, onClose) => {
  return (dispatch) => {
    API.post(`https://new-slimadmin.site.supplies/api/course/activate-course`, {
      course_id: course_id,
      start_date: start_date,
    })
      .then((respons) => {
        if (respons.status === 200) {
          toastSuccess('Курса успешно активирован');
          dispatch(setUpdateStatusCourse(index));
          onClose();
        }
      })
      .catch((err) => {
        if (err && err.response && err.response.data && err.response.data.message) {
          toastError(err.response.data.message);
        } else toastError('Не удалось активировать курс');
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/newYouslim.js